<script>
import MdsForm from "@mds/form";
import MdsFieldset from "@mds/fieldset";
import FormElement from "./FormElement.vue";
import MdsLoader from "@mds/loader";
import { MdsButton } from "@mds/button";
import MdsSection from "@mds/section";
import { MdsTabs, MdsTabsItem } from "@mds/tabs";
import AdlDataList from "../DataList/DataList.vue";
import { fileURLToPath } from "url";
export default {
  name: "AdlExpandableEloquaForm",
  props: {
    tabs: { type: Array, required: true },
    sections: { type: Array, required: true },
    sectionElements: { type: Array, required: true },
    formSubmitElements: { type: Array, required: true },
    elements: {
      type: Array,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: "medium",
    },
  },
  mounted() {
    this.rootElement = this.$refs.root;

    this.rootElement.addEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      form: Object.assign({}, this.elements),
      formSection: Object.assign([], this.sections),
      formTabs: Object.assign([], this.tabs),
      listdata: [],
      selectedTab: this.tabs[0].id,
    };
  },
  components: {
    MdsForm,
    MdsFieldset,
    MdsLoader,
    MdsTabs,
    MdsTabsItem,
    MdsSection,
    FormElement,
    MdsButton,
    AdlDataList,
  },
  methods: {
    handleScroll() {},
    enableTab(id) {
      this.formTabs.forEach((item) => {
        if (item.id == id) {
          this.selectedTab = item.id;
          item.active = true;
        } else {
          item.active = false;
        }
      });
    },
    setActiveItem(event) {
      this.enableTab(event.currentTarget.id);
      this.selectedTab = event.currentTarget.id;
      let className = "formsection" + event.currentTarget.id;
      this.setFocus(className);
    },
    setFocus(className) {
      let chartContainerElement = this.$el.getElementsByClassName(className);
      if (chartContainerElement && chartContainerElement.length > 0) {
        chartContainerElement[0].scrollIntoView({ behavior: "smooth" });
      }
    },
    inputChange(groupId) {
      this.$emit("formChange", groupId);
    },
    dropDownChange(callBackMethod, selectedValue, groupId) {
      if (callBackMethod) {
        this.$emit("dropDownChange", callBackMethod, selectedValue, groupId);
      } else {
        this.$emit("formChange", groupId);
      }
    },
    EditDataList(data) {
      this.$emit("EditDataList", data);
    },
    toggleSection(index) {
      this.formSection.forEach((item, id) => {
        if (index == id) {
          item.isExpand = !item.isExpand;
          this.$nextTick(() => {
            this.setFocus("section" + index);
          });
        } else {
          item.isExpand = false;
        }
      });
    },
  },
  destroyed() {
    this.rootElement.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<template>
  <div
    ref="root"
    :class="[$style['adl-components-ui__expandable-eloqua-form']]"
  >
    <div>
      <mds-form :size="size" autocomplete="on" @submit.prevent.native="">
        <mds-section
          v-for="(section, index) in formSection"
          :title="section.sectionTitle"
          :border="index == 0 ? 'none' : 'tertiary'"
          :class="[
            $style['margin-section'],
            'section' + index,
            'formsection' + section.sectionTabId,
          ]"
          bold
          :size="7"
        >
          <template #mds-section-supplemental-content>
            <mds-button
              variation="icon-only"
              :iconRight="
                section.isExpand ? 'caret-circle-up' : 'caret-circle-down'
              "
              type="button"
              @click="toggleSection(index)"
            ></mds-button>
          </template>
          <div v-if="section.isExpand">
            <span :class="[$style['sectionHeading']]">{{
              section.sectionHeading
            }}</span>
            <mds-fieldset
              v-if="sectionElements.length - 1 >= index"
              :disabled="loading"
              hidden-legend
            >
              <div
                v-for="format in sectionElements[index].groupElement"
                :class="[$style['cfSet'], $style[format.class]]"
              >
                <div v-if="format.name" :class="$style['group-title']">
                  {{ format.name }}
                </div>

                <form-element
                  v-if="format.subGroup.length == 0"
                  :groupElement="format.element"
                  :elements="elements"
                  :groupId="format.id"
                  @dropDownChange="dropDownChange"
                  @formChange="inputChange"
                  @EditDataList="EditDataList"
                >
                  <template v-if="$slots.tooltipText" v-slot:tooltipText>
                    <slot v-if="$slots.tooltipText" name="tooltipText"></slot>
                  </template>
                </form-element>
                <template v-for="subGroupElement in format.subGroup">
                  <form-element
                    :groupElement="subGroupElement.element"
                    :elements="elements"
                    :isInline="subGroupElement.isInline"
                    :addDefaultMargin="subGroupElement.addDefaultMargin"
                    :relativePosition="subGroupElement.relativePosition"
                    :groupId="format.id"
                    @dropDownChange="dropDownChange"
                    @formChange="inputChange"
                    @EditDataList="EditDataList"
                  >
                    <template v-slot:tooltipText>
                      <slot name="tooltipText"></slot>
                    </template>
                  </form-element>
                </template>
              </div>
            </mds-fieldset>
          </div>
        </mds-section>
        <div>
          <slot name="outsideGroup"></slot>
        </div>
        <div>
          <template v-for="element in formSubmitElements">
            <mds-button
              :data-id="element.id"
              v-if="element.displayType === 'submit'"
              :size="size"
              :variation="element.variation"
              :type="element.htmlName"
              :key="element.id"
              style="margin-right: 10px; margin-top: 24px"
              :disabled="element.isdisabled"
              @click="$emit('submit', element.emitevent)"
              >{{ element.name }}</mds-button
            >

            <span
              v-else-if="element.displayType === 'link'"
              :class="$style['my-link']"
              @click="$emit('submit', element.emitevent)"
              href="#"
              >{{ element.name }}</span
            >
          </template>
        </div>
      </mds-form>
    </div>

    <div :class="$style.loader" v-if="loading">
      <mds-loader aria-label="Submitting form ..."></mds-loader>
      <h6>Submitting form</h6>
    </div>
  </div>
</template>

<style module lang="scss">
@import "@mds/constants";
@import "@mds/typography";
@import "@mds/link";
.adl-components-ui__expandable-eloqua-form {
  .sectionHeading {
    position: relative;
    top: -15px;
  }
  .mds-section__supplemental-content {
    padding-top: 2px;
  }
  .cfSet {
    width: 100%;
    float: left;
  }
  .mdsswitch {
    margin-top: 10px;
  }
  .margin-section {
    margin-top: $mds-space-2-x;
  }

  .group-section {
    border-top: $mds-border-separator-on-light;
    padding-top: $mds-space-2-x;
    margin-top: $mds-space-2-x;
  }
  .group-title {
    @include mds-eyebrow-heading();
    font-size: $mds-space-inset-s !important;
    margin-bottom: $mds-space-1-x;
  }
  .my-link {
    @include mds-link();
    color: $mds-interactive-color-primary-default !important;
    float: right;
    margin-top: 30px;
    font-size: 14px;
    line-height: 16px;
    border-bottom: 1px solid $mds-interactive-color-primary-default;
    cursor: pointer;
  }
  .mds-range-slider .mds-range-slider__input {
    flex: 0 0 50%;
  }
  .loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: hsla(0, 100%, 0%, 0.2);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    h6 {
      @include mds-eyebrow-heading;
    }
  }

  .mds-form--medium-layout {
    .mds-label {
      margin-bottom: $mds-space-2-x;
    }

    .mds-range-slider {
      margin-bottom: $mds-space-2-x;
      &:last-child {
        margin-bottom: 0px;
      }
      .mds-label {
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>
